import { AlertTriangle } from 'lucide-react';
import { Component, type ReactNode } from 'react';
import { setView } from '../store';
import { Empty } from './common';

/**
 * Keeps a page that crashes from taking the whole app with it. Without this, React empties the
 * page, and since the address names the view, reloading opens the same crash again. Give it the
 * view as its key, so switching pages starts fresh.
 */
export class ViewBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <Empty icon={<AlertTriangle size={28} />} title="This page ran into a problem">
        <p className="faint small-text" style={{ margin: '0 0 12px' }}>
          Your tree is safe. {error.message}
        </p>
        <div className="row" style={{ justifyContent: 'center' }}>
          <button className="btn" onClick={() => this.setState({ error: null })}>
            Try again
          </button>
          <button className="btn primary" onClick={() => setView('tree')}>
            Go to the Tree
          </button>
        </div>
      </Empty>
    );
  }
}
